var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "frequency-content" },
    [
      _c("mds-input", {
        attrs: {
          label: _vm.translate("frequency.modal.name.label"),
          placeholder: _vm.translate("frequency.modal.name.placeholder"),
          error: !!_vm.error.length,
          "error-text": [_vm.error],
        },
        model: {
          value: _vm.name,
          callback: function ($$v) {
            _vm.name = $$v
          },
          expression: "name",
        },
      }),
      _vm._v(" "),
      _c("frequency-recurrence", _vm._g({}, _vm.$listeners)),
      _vm._v(" "),
      _c("start-date", {
        attrs: {
          label: _vm.translate("frequency.modal.date.label"),
          startDate: _vm.startDate,
        },
        on: {
          input: function ($event) {
            _vm.$emit("input", $event)
            _vm.startDate = $event.startDay
          },
          validDate: function ($event) {
            return _vm.$emit("validDate", $event)
          },
        },
      }),
      _vm._v(" "),
      _c("Time", {
        attrs: {
          time: _vm.time,
          timezones: _vm.timezones,
          "is-same-day": _vm.sameDay,
          "repeat-type": _vm.repeatType,
          "start-date": _vm.startDate,
          timezone: _vm.timezone,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
          error: function ($event) {
            return _vm.$emit("error", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }